const comments = [
  {
    name: '吃瓜不嫌事大',
    time: '3小时前',
    content: '这个网站真的太强了，之前那个美妆博主塌房我就是在这里第一时间看到的！比其他平台都快，现在每天必刷，不吃瓜浑身难受哈哈哈。',
    likes: '2.3k',
  },
  {
    name: '理性吃瓜群众',
    time: '6小时前',
    content: '说实话现在网红圈真的太乱了，还好有这个平台把所有黑料整理得清清楚楚。每篇都标注了信息来源，不瞎传谣言，吃瓜也吃得明明白白。',
    likes: '1.8k',
  },
  {
    name: '爆料小能手',
    time: '12小时前',
    content: '已经把这个网站推荐给身边所有朋友了！更新速度真的快，而且每次大瓜都有深度分析。之前那个税务风波的时间线梳理真的太专业了，必须点赞！',
    likes: '3.1k',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1400px] mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">吃瓜群众说</h2>
            <p className="mt-2 text-sm text-foreground-500">来自真实用户的声音，吃瓜路上的同行者</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 max-w-4xl mx-auto">
            {comments.map((comment, idx) => (
              <div
                key={idx}
                className="p-5 rounded-xl bg-background-200/70 border border-background-300/40"
              >
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-10 h-10 rounded-full bg-accent-500/20 flex items-center justify-center">
                    <span className="text-accent-500 font-heading text-sm">
                      {comment.name.charAt(0)}
                    </span>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-foreground-800">{comment.name}</p>
                    <p className="text-xs text-foreground-400">{comment.time}</p>
                  </div>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed">{comment.content}</p>
                <div className="mt-4 flex items-center gap-1 text-xs text-foreground-400">
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-thumb-up-line"></i>
                  </span>
                  {comment.likes}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}